import { setState } from './store.js';

// Not stored in the reactive store: a ServiceWorkerRegistration/Worker
// instance isn't state the render layer should hold — only the boolean
// "is an update available" flag is.
let waitingWorker = null;

export function initSwUpdateWatcher() {
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      if (reg.waiting && navigator.serviceWorker.controller) {
        waitingWorker = reg.waiting;
        setState({ swUpdateAvailable: true });
      }
      reg.addEventListener('updatefound', () => {
        const installing = reg.installing;
        if (!installing) return;
        installing.addEventListener('statechange', () => {
          if (installing.state === 'installed' && navigator.serviceWorker.controller) {
            waitingWorker = installing;
            setState({ swUpdateAvailable: true });
          }
        });
      });
    }).catch(() => {});
  });

  // A first-ever visit also fires 'controllerchange' (the just-installed
  // worker calls clients.claim() and takes control of the already-loaded
  // page) — that's not an update, so only reload when this page already
  // had a controller before the change, meaning a *different* worker just
  // took over.
  const hadController = !!navigator.serviceWorker.controller;
  let reloading = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!hadController || reloading) return;
    reloading = true;
    window.location.reload();
  });
}

export function applySwUpdate() {
  if (!waitingWorker) return;
  waitingWorker.postMessage('SKIP_WAITING');
  setState({ swUpdateAvailable: false });
}
